var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "list-dnt" } },
    [
      _c("ApprovalFilters", {
        model: {
          value: _vm.filters,
          callback: function($$v) {
            _vm.filters = $$v
          },
          expression: "filters"
        }
      }),
      _c("FilesHeader"),
      _c(
        "div",
        { key: _vm.forceRender, staticClass: "force-render" },
        _vm._l(_vm.files, function(file) {
          return _c("FileRow", {
            key: file.febosId,
            attrs: {
              file: file,
              "select-file": _vm.selectFile,
              "data-cy": "file"
            }
          })
        }),
        1
      ),
      _c("PopUpBinnacleFile", {
        attrs: { titulo: "Bitácora del Expediente #" + _vm.selectedFile.numero }
      }),
      _c("PopUpCancelFile", { attrs: { canceledFile: _vm.selectedFile } }),
      _c("FilesPagination", {
        attrs: { show: _vm.files.length },
        model: {
          value: _vm.page,
          callback: function($$v) {
            _vm.page = $$v
          },
          expression: "page"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }